import CryptoJS from "crypto-js";

/**
 * Hex-строку → WordArray (crypto-js формат)
 */
function hexToWordArray(hex) {
    return CryptoJS.enc.Hex.parse(hex);
}

/**
 * HMAC-SHA256 подпись для imgproxy
 * salt (hex) + path → HMAC-SHA256(key) → base64url без padding
 */
function signPath(key, salt, path) {
    const saltWA = hexToWordArray(salt);
    const pathWA = CryptoJS.enc.Utf8.parse(path);

    // Конкатенация: salt || path
    const data = saltWA.clone().concat(pathWA);

    const hmac = CryptoJS.HmacSHA256(data, hexToWordArray(key));
    const signature = CryptoJS.enc.Base64.stringify(hmac).replace(/\+/g, "-").replace(/\//g, "_").replace(/=+$/, "");

    return signature;
}

export default (context, inject) => {
    // SSR-safe base64 encoder
    const urlSafeBase64 = (string) => {
        let encoded;
        if (typeof window === "undefined") {
            // server (Node.js)
            encoded = Buffer.from(string, "utf-8").toString("base64");
        } else {
            // client (browser)
            encoded = window.btoa(unescape(encodeURIComponent(string)));
        }

        return encoded.replace(/=/g, "").replace(/\+/g, "-").replace(/\//g, "_");
    };

    const proxy = process.env.IMGPROXY_URL || "https://i.post-post-scriptum.com";
    const key = process.env.IMGPROXY_KEY;
    const salt = process.env.IMGPROXY_SALT;
    const hasCredentials = key && salt;
    const resizingType = "fill";

    /**
     * Генерирует подписанный (или unsecure) URL для path
     */
    const buildUrl = (path) => {
        const fullPath = `/${path}`;
        if (hasCredentials) {
            const signature = signPath(key, salt, fullPath);
            return `${proxy}/${signature}${fullPath}`;
        }
        return `${proxy}/unsecure${fullPath}`;
    };

    const img = {
        // TODO вернуть кроппер
        resizeOld(path /*size, mode = "resize"*/) {
            if (!path) path = "https://post-post-scriptum.com/img/not-found.jpg";
            return `${path}`;
        },
        resize(imgUrl, width, height = 0) {
            // if (process.env.NODE_ENV !== "production") {
            //     return {
            //         srcJpg: imgUrl,
            //         srcsetJpg: imgUrl,
            //         srcWebp: imgUrl,
            //         srcsetWebp: imgUrl,
            //     };
            // }

            if (!imgUrl) {
                return {
                    srcJpg: "",
                    srcsetJpg: "",
                    srcWebp: "",
                    srcsetWebp: "",
                };
            }

            const encodedUrl = urlSafeBase64(String(imgUrl));
            const path = `rs:${resizingType}:${width}:${height}:0/q:80/el:1/${encodedUrl}.jpg`;
            const pathX2 = `rs:${resizingType}:${width}:${height}:0/q:80/el:1/dpr:2/${encodedUrl}.jpg`;
            const pathWebp = `rs:${resizingType}:${width}:${height}:0/q:80/el:1/${encodedUrl}.webp`;
            const pathX2Webp = `rs:${resizingType}:${width}:${height}:0/q:80/el:1/dpr:2/${encodedUrl}.webp`;

            return {
                srcJpg: buildUrl(path),
                srcsetJpg: `${buildUrl(pathX2)} 2x`,
                srcWebp: buildUrl(pathWebp),
                srcsetWebp: `${buildUrl(pathX2Webp)} 2x`,
            };
        },
        resizeSimple(imgUrl, width, height = 0) {
            const encodedUrl = urlSafeBase64(String(imgUrl));
            const path = `rs:${resizingType}:${width}:${height}:0/q:80/el:2/${encodedUrl}.webp`;
            return buildUrl(path);
        },
    };
    inject("img", img);
    context.$img = img;
};
